import { Controller } from "@hotwired/stimulus";
// Use bundle to import everything
// import Swiper from "swiper/bundle";
import Swiper from "swiper";
import { Autoplay, EffectFade } from "swiper/modules";

// Connects to data-controller="fader"
export default class extends Controller {
  connect() {
    this.swiper = new Swiper(".swiper-container", {
      modules: [Autoplay, EffectFade],
      loop: true,
      effect: "fade",
      fadeEffect: {
        crossFade: true,
      },
      speed: 3000,
      autoplay: {
        delay: 3000,
      },
    });
  }
}
